import axiosConfig from "./axiosConfig";

export interface AxpoSiteNameMapping {
  siteId: string;
  siteName: string;
  axpoSiteName: string;
  createdAt: string;
  updatedAt: string;
  createdByEmail: string;
}

export interface ListAxpoSiteNameMappingsResponse {
  axpoSiteNameMappings: AxpoSiteNameMapping[];
}

const listAxpoSiteNameMappings = async (
  authToken: string
): Promise<ListAxpoSiteNameMappingsResponse> => {
  const { data } = await axiosConfig.get(
    "/admin/axpo-counter-invoice/site-name-mappings",
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default listAxpoSiteNameMappings;
